import React from "react";

import Button from "@material/react-button";
import { ChipSet, Chip } from "@material/react-chips";
import { Container, Row, Col } from "reactstrap";
import GitHub from "react-ionicons/lib/LogoGithub";
import MaterialIcon from "@material/react-material-icon";
import Slide from "react-reveal/Slide";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import Carousel from "./Flickity";
import { Resources } from "../../contexts/ResourcesContext";

class Project extends React.Component {
  static propTypes = {
    project: PropTypes.shape({
      slug: PropTypes.string,
      name: PropTypes.string,
      date: PropTypes.string,
      subtitle: PropTypes.string,
      description: PropTypes.string,
      video: PropTypes.string,
      organization: PropTypes.string,
      tags: PropTypes.arrayOf(PropTypes.string),
      github: PropTypes.string,
      link: PropTypes.string,
      people: PropTypes.number
    }).isRequired,
    history: PropTypes.object
  };

  state = {
    reveal: true
  };

  _backHome = () => {
    this.props.history.push("/");
  };

  render() {
    const { project } = this.props;
    const projects =
      project !== undefined
        ? require("../../data").filter(p => p.slug !== project.slug)
        : require("../../data");

    return (
      <div className="project">
        <Container>
          <Button
            raised
            onClick={this._backHome}
            icon={<MaterialIcon icon="arrow_back_ios" />}
          >
            Back to the homepage
          </Button>

          {project !== undefined ? (
            <div>
              <Slide bottom key={project.slug}>
                <div className="text-center header">
                  <h1 className="display-1">{project.name}</h1>
                  <h5>{project.subtitle}</h5>
                  <h6>
                    {project.date} -
                    <MaterialIcon
                      icon="person"
                      style={{
                        background: "inherit",
                        verticalAlign: "bottom"
                      }}
                    />
                    {project.people}
                  </h6>

                  <ChipSet className="d-flex justify-content-center">
                    {project.tags.map(t => (
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        key={t.toLowerCase()}
                        href={`https://www.ecosia.org/search?q=${encodeURI(t)}`}
                      >
                        <Chip id={t.toLowerCase()} label={t} />
                      </a>
                    ))}
                  </ChipSet>
                </div>
              </Slide>
              <Slide bottom>
                <Row className="justify-content-center mb-3">
                  <Col md={4} className="text-center">
                    {"video" in project ? (
                      <div className="embed-responsive embed-responsive-3by4">
                        <iframe
                          className="embed-responsive-item"
                          title={`${project.name} video`}
                          src={`https://player.vimeo.com/video/${project.video}`}
                          allowFullScreen
                        />
                      </div>
                    ) : project.slug in Resources.images ? (
                      <a
                        href={Resources.images[project.slug]}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-picture"
                      >
                        <img
                          src={Resources.images[project.slug]}
                          alt={project.name}
                          className="img-fluid"
                        />
                      </a>
                    ) : (
                      <img
                        src={Resources.logos[project.slug]}
                        alt={project.name}
                        className="img-fluid"
                      />
                    )}
                  </Col>
                  <div className="w-100" />
                  <Col md={4}>
                    <MaterialIcon
                      icon="format_quote"
                      style={{ fontSize: 44 }}
                    />
                    <p
                      className="text-justify"
                      dangerouslySetInnerHTML={{ __html: project.description }}
                    />
                  </Col>
                  {(project.link || project.github) && (
                    <Col md={12} className="text-center">
                      {project.link && (
                        <Button
                          href={project.link}
                          target="_blank"
                          className="mx-1"
                          icon={<MaterialIcon icon="public" />}
                        >
                          Have a look to the project
                        </Button>
                      )}
                      {project.github && (
                        <Button
                          href={project.github}
                          target="_blank"
                          icon={<GitHub color="black" />}
                          className="mx-1"
                        >
                          See on GitHub
                        </Button>
                      )}
                    </Col>
                  )}
                </Row>
              </Slide>
            </div>
          ) : (
            <div>
              <h3 className="my-5">This project doesn't exist</h3>
            </div>
          )}
        </Container>
        <Slide bottom>
          <div className="carousel-container">
            <h3 className="text-center mb-1 h2">
              You can also look at those projects
              <br />
              <small>Just click on the tiles to navigate</small>
            </h3>
            <Carousel
              projects={projects}
              options={{
                draggable: false,
                cellAlign: "left",
                freeScroll: false,
                wrapAround: true,
                autoPlay: 3500,
                pauseAutoPlayOnHover: true,
                imagesLoaded: true,
                percentPosition: true,
                cellSelector: ".carousel-cell"
              }}
            />
          </div>
        </Slide>
      </div>
    );
  }
}

export default withRouter(Project);
